<template lang="pug">
.empty-state
  .icon
    img(src="~assets/empty-state.png")
  .copy {{copy}}
  
</template>
<script>
export default {
  name: 'EmptyState',
  props: {
    copy: {},
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.empty-state
  width: 100%
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  .icon
    width: pxToRem(300)
    img
      width: 100%
      object-fit: contain
  .copy
    color: black
    font-size: 20px
</style>
